import React from 'react';

import BackIcon from 'assets/images/icons/back-desktop.svg';
import BackIconWhite from 'assets/images/icons/back-desktop-white.svg';

import { IBackButton } from './interfaces';
import { BackButtonContainer, BackButtonIcon } from './styles';

export const BackButton: React.FC<IBackButton> = ({
  isSuccess,
  onBack,
  onClick,
  colorBackButton,
}) => {
  return (
    <>
      <BackButtonContainer
        isSuccess={isSuccess}
        onClick={() => {
          return onClick;
        }}
        role="button"
        onKeyDown={() => {
          onBack();
        }}
        tabIndex={0}
        colorBackButton={colorBackButton}
      >
        <img
          src={colorBackButton === 'white' ? BackIconWhite : BackIcon}
          alt="Seta para Esquerda"
          color="white"
        />
        <p>Voltar</p>
      </BackButtonContainer>

      <BackButtonIcon
        onClick={() => {
          return onClick;
        }}
      >
        <img
          src={colorBackButton === 'white' ? BackIconWhite : BackIcon}
          alt="Voltar"
        />
      </BackButtonIcon>
    </>
  );
};

export default BackButton;
